import styled from '@emotion/styled';
import {
  COLOR,
  BREAKPOINTS,
  FONT_SIZE,
  FONT_WEIGHT,
} from '@ordermentum/ui-constants';

const PAGE_WRAP_POINT = BREAKPOINTS.TABLET_MIN;

type LoginType = 'default' | 'magicLink';

export const Background = styled('div')`
  background-color: ${COLOR.WHITE};
  min-width: 100vw;
  min-height: 100vh;
`;

export const HeaderWrapper = styled('div')`
  width: 100%;
  border-bottom: 1px solid ${COLOR.GRAY_DEDEDE};
  padding: 2rem 0;

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    padding: 1rem 0;
  }
`;

export const PageContainer = styled('div')<{ type?: LoginType }>`
  max-width: 65%;
  margin: auto;

  display: ${p => (p.type === 'default' ? 'flex' : 'block')};
  ${p => (p.type === 'default' ? 'justify-content:center' : undefined)};

  @media screen and (max-width: ${BREAKPOINTS.TABLET_MAX}) {
    max-width: 80%;
  }

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    max-width: 100%;
    margin: 0 1.5rem;
  }
`;

export const BodyContainer = styled('div')<{ type?: LoginType }>`
  display: flex;
  flex-direction: row;
  justify-content: ${p => (p.type === 'default' ? 'center' : 'space-between')};
  margin-top: 3rem;

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    margin-top: 2rem;
    flex-direction: column;
  }
`;

export const ChildContent = styled('div')`
  flex-basis: 50%;
`;

export const SignInContainer = styled('div')`
  flex-basis: 40%;
  margin-bottom: 2rem;

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    margin-top: 1rem;
  }
`;

export const SplashImage = styled('img')`
  width: 100%;
`;

export const SplashHeading = styled('h1')`
  font-size: ${FONT_SIZE.XL};
  font-weight: ${FONT_WEIGHT.BOLD};
  margin: 0.67rem 0;
`;

export const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    flex-direction: column;
  }
`;

export const LogoContainer = styled('div')`
  display: flex;
`;

export const HeaderImage = styled('img')`
  width: 5.5rem;
  height: 5.5rem;
`;

export const HeaderTitle = styled('h1')`
  font-size: ${FONT_SIZE.XL};
  font-weight: ${FONT_WEIGHT.BOLD};
  margin: 0 0 0 1rem;
  align-self: center;
`;

export const PoweredContainer = styled('div')`
  display: flex;
  align-items: flex-end;
  min-width: 17.5rem;

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    margin-top: 1rem;
  }
`;

export const PoweredByText = styled('div')`
  font-size: ${FONT_SIZE.SM};
  font-weight: ${FONT_WEIGHT.NORMAL};
  color: ${COLOR.GRAY_500};
  margin: 0 0.5rem 0 0;
  padding-bottom: 0.2rem;

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 0.3rem;
  }
`;
export const OrdermentumLogo = styled('img')`
  width: 12rem;

  @media screen and (max-width: ${PAGE_WRAP_POINT}) {
    width: 8;rem;
  }
`;
